<script>
	import { getContext } from "svelte";
	import { fade } from "svelte/transition";

	const { custom } = getContext("LayerCake");

	let nodeHighlight = $custom.nodeHighlight;

	export let link;
	export let highlighted;
	export let formatValue;

	// get the node that is not highlighted, if there is one (could also be that the link itself is highlighted and no node)
	$: highlightedNode =
		$nodeHighlight?.length === 1 ? ($nodeHighlight[0] === link.target.id ? link.target : link.source) : undefined;

	// calculate the relative value of the link compared to the highlighted node
	$: relativeValue = link.value / highlightedNode?.value;

	// show the label if the link is at least 10% of the value of the highlighted node or if there is no highlighted node
	$: showLabel = relativeValue > 0.1 || !highlightedNode;
</script>

{#if highlighted}
	{#if showLabel}
		<div class="value" transition:fade>
			{formatValue(link.value)}
		</div>
		<div class="label" transition:fade>
			{#if highlightedNode?.type === "source"}
				nach {link.target.label}
			{:else if highlightedNode?.type === "target"}
				von {link.source.label}
			{:else}
				{link.source.label} nach {link.target.label}
			{/if}
		</div>
	{/if}
{/if}

<style lang="scss">
	* {
		font-weight: $bold;
		text-align: center;
		text-shadow: 0px 0px 4px #fff;
		color: #343035;
	}

	.label {
		opacity: 0.65;
		font-size: 11px;
	}
</style>
